import React, { Component } from 'react';
import './profile.css';


function ProfileSettings (props){

  return(
    <h1 className="main-h1 profile-h1">Gift Cards...Settings!</h1>
)
}






export default ProfileSettings;



// WEBPACK FOOTER //
// ./src/profilesettings.js